import React from "react";
import assign from "lodash/assign";
import set from "lodash/set";
import get from "lodash/get";
import randomstring from "just.randomstring";
import { TextField, RaisedButton } from "material-ui";
import { colors as Colors } from "material-ui/styles";

import WorkingIndicator from "./partials/working-indicator.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import KioskActions from "../actions/KioskActions";
import KioskStore from "../stores/KioskStore";

class Kiosk extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      kiosk: null,
      dirty: false,
      values: {}
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.makeNewRandomCode = this.makeNewRandomCode.bind(this);
    this.save = this.save.bind(this);
    this.delete = this.delete.bind(this);
  }

  static getStores() {
    return [KioskStore];
  }

  static getPropsFromStores() {
    return {
      getKioskById: KioskStore.getKioskById
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      actions: {
        marginTop: 40
      },
      a: {
        color: Colors.lightBlue700,
        textDecoration: "underline",
        cursor: "pointer"
      },
      h3: {
        marginTop: 30,
        marginBottom: 10
      }
    };
  }

  onChange(id, e, checked) {
    this.onChangeValue(
      id,
      typeof checked !== "undefined" ? !this.state.values[id] : e.target.value
    );
  }

  onChangeValue(id, value) {
    this.state.dirty = true;
    set(this.state.values, id, value);
    this.setState(this.state);
  }

  makeNewRandomCode() {
    this.state.dirty = true;
    this.state.values.code = randomstring(15, "numbers_uppercases");
    this.setState(this.state);
  }

  save() {
    var values = assign({}, this.state.values);

    if (values.target && values.target.ids) {
      values.target.ids = values.target.ids.split(/\s*,\s*/g);
    }

    KioskActions.edit(this.props.params.kioskId, values);
  }

  delete() {
    let bucket = this.state.kiosk.event_bucket;
    if (window.confirm("Are you sure?")) {
      KioskActions.delete(this.props.params.kioskId);
      this.context.router.push(`/event_buckets/${bucket}/kiosks`);
    }
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    var kiosk = newProps.getKioskById(newProps.params.kioskId);

    if (!this.state.isFetchingKiosk && !kiosk) {
      KioskActions.fetchOne(newProps.params.kioskId);
      this.setState({ isFetchingKiosk: true });
    } else if (kiosk) {
      this.setState({ isFetchingKiosk: false });
    }

    this.setState({
      kiosk,
      dirty: false,
      values: kiosk
        ? {
            name: kiosk.name || "",
            code: kiosk.code || "",
            printer: kiosk.printer || ""
          }
        : {}
    });
  }

  render() {
    var styles = this.getStyles();

    if (!this.state.kiosk) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        <div>
          <div>
            <TextField
              value={get(this.state, "values.name", "")}
              floatingLabelText="Name"
              onChange={e => this.onChangeValue("name", e.target.value)}
            />
          </div>
          <div>
            <TextField
              value={get(this.state, "values.code", "")}
              floatingLabelText="Code"
              onChange={e => this.onChangeValue("code", e.target.value)}
            />
            <div>
              <a style={styles.a} onTouchTap={this.makeNewRandomCode}>
                Generate a new random code
              </a>
            </div>
          </div>
          <div>
            <TextField
              value={get(this.state, "values.printer", "")}
              floatingLabelText="Printer"
              onChange={e => this.onChangeValue("printer", e.target.value)}
            />
          </div>
        </div>
        <div style={styles.actions}>
          <RaisedButton
            label={this.state.dirty ? "Save changes" : "No changes to save"}
            primary={true}
            disabled={!this.state.dirty}
            onTouchTap={this.save}
          />
          <RaisedButton
            label="Delete kiosk"
            onTouchTap={this.delete}
            style={{ marginLeft: 7 }}
          />
        </div>
      </div>
    );
  }
}

export default connectToStores(Kiosk);



// WEBPACK FOOTER //
// ./src/app/components/kiosk.jsx